<template>

    <div class="upload-btn-wrapper">        
        
        <b-button id="b-in-file" class="btn-input-file">Загрузить</b-button>
        
        <label v-if="!urlFileOpen" id="label-input-file" for="b-in-file">{{labelText}}</label>        
        
        <label v-else 
               id="label-input-file" 
               for="b-in-file">
            <a target="_blank" class="admin-link" :href="urlFileOpen">{{textFileDownloaded}}</a>
        </label>

        <input 
            type="file" 
            class="input-file" 
            :accept="accept" 
            @change="onFileChange"/>
    </div>
    
</template>

<script>
import '@/assets/styles/shared/openFileDialog.css'

import FileObject from '@/store/models/admin/standardBooks/FileObject'

export default {
    model: {
        prop: 'value',
        event: 'select'
    },
    props:{
        value: FileObject,
        urlFileOpen:{
            type: String,
            default: null
        },
        accept: {
            type: String,
            default: "application/pdf"
        },
        maxImageWidth: {
            type: Number,
            default: 200
        },
        maxImageHeight:{
            type: Number,
            default: 200
        },
        isImage: {
            type: Boolean,
            default: false
        },
        isSizeCheck: {
            type: Boolean,
            default: true
        }
    },
    data: function(){
        return{
            objectFile: this.value
        };
    },
    computed:{
        labelText: function() {
            return this.objectFile.FileName == "" ? "Файл не выбран" : this.objectFile.FileName
        },
        textFileDownloaded: function() {
            return this.isImage ? "Открыть файл" : "Просмотреть книгу стандартов";
        }
    },
    methods: {

        onFileChange: function(e) {
            var files = e.target.files || e.dataTransfer.files;                
            this.objectFile.FileName = files[0].name;
            this.objectFile.Type = files[0].type;

            if (!files.length)
                return;
            
            if (this.objectFile.IsImage()) {
                var self = this;
                this.downloadFile(files[0])
                    .then(e => this.onImageLoad(self, e))
                    .catch(error => console.error(error));
                
            } else {
                this.downloadFile(files[0])
                    .then(e => {
                        this.objectFile.File = e.target.result;
                        this.$emit('select', this.objectFile);  
                    })
                    .catch(error => console.error(error));
            }
        },

        onImageLoad: function(self, event) {
            var file = event.target.result;

            self.getImage(file)
                .then(f => {
                    var image = f.target;
                    var isValid = image.width <= self.maxImageWidth &&
                                  image.height <= self.maxImageHeight;
                    
                    if (isValid || !this.isSizeCheck) {
                        self.objectFile.File = file;
                        self.$emit('select', self.objectFile);
                    } else {
                        self.$emit('error', null);
                        self.objectFile.clean();
                    }
                        
                })
                .catch(error => console.error(error));
        },

        downloadFile: function(file) {
            return new Promise((resolve, reject) => {
                let reader = new FileReader();
                reader.onload = resolve;
                reader.onerror = reject;
                reader.readAsDataURL(file);
            })
        },

        getImage: function(base64Image) {
            return new Promise((resolve, reject) => {
                let img = new Image();
                img.onload = resolve;
                img.onerror = reject;
                img.src = base64Image;
            })
        }
        
    }
}
</script>